import React from 'react'
import PropTypes from 'prop-types'
import * as SharedStyled from '../../styles/base.styled'
import NavBar from '../Navbar/Navbar'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { AddBasketModals } from 'src/features/add-basket/ui'
import { ErrorMessageDesktop } from '@entities/error-message/ui/error-message-desktop'
import CatalogMenuState from '@context/CatalogMenuState'

const Base = (props) => (
    <SharedStyled.CenterPage>
        <SharedStyled.PageContainer>
            <SharedStyled.Page>
                <NavBar />
                <CatalogMenuState>
                    <Header />
                </CatalogMenuState>
                <SharedStyled.Body>{props.children}</SharedStyled.Body>
            </SharedStyled.Page>
            <Footer />
            <AddBasketModals />
            <ErrorMessageDesktop />
        </SharedStyled.PageContainer>
    </SharedStyled.CenterPage>
)
Base.propTypes = {
    children: PropTypes.node.isRequired
}
export default Base
